module.exports = __webpack_public_path__ + "img/food.b03bfd14.svg";